module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_c-e14469f8a34418b25c229a40c2909079.png";